exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.module-container[data-v-d9ca832a] {\n    display: flex;\n    flex-wrap: wrap;\n}\n.cards-container[data-v-d9ca832a] {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.card-status-center[data-v-d9ca832a]{\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n#queueSelect[data-v-d9ca832a] {\n    width: 200px !important\n}\n", ""]);

// exports
